import React from "react";
import "./FlightBookingModal.css";

const FlightBookingModal = ({ flight, onClose }) => {
  const itinerary = flight.itineraries?.[0];
  const segment = itinerary?.segments?.[0];
  const carrier = segment?.carrierCode || "N/A";
  const fromAirport = segment?.departure?.iataCode || "N/A";
  const toAirport = segment?.arrival?.iataCode || "N/A";
  const departureTime = new Date(segment?.departure?.at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const arrivalTime = new Date(segment?.arrival?.at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const price = flight.price?.total || "N/A";
  const validatingAirlines = flight.validatingAirlineCodes?.join(", ") || "N/A";

  return (
    <div className="booking-modal-overlay" onClick={onClose}>
      <div className="booking-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Book Your Flight</h3>
        <div className="booking-flight-info">
          <p><strong>Airline:</strong> {carrier}</p>
          <p><strong>From:</strong> {fromAirport}</p>
          <p><strong>To:</strong> {toAirport}</p>
          <p><strong>Departure:</strong> {departureTime}</p>
          <p><strong>Arrival:</strong> {arrivalTime}</p>
          <p><strong>Price:</strong> ₹{Number(price).toLocaleString()}</p>
          <p><strong>Validating Airline:</strong> {validatingAirlines}</p>
        </div>
        <form 
          action="https://formspree.io/f/mrbkvpql" 
          method="POST"
          className="booking-form"
        >
          <input
            name="name"
            placeholder="Your Name"
            required
          />
          <input
            name="email"
            type="email"
            placeholder="Your Email"
            required
          />
          <input
            name="phone"
            placeholder="Your Phone"
            required
          />
          {/* hidden fields to submit flight details too */}
          <input type="hidden" name="airline" value={carrier} />
          <input type="hidden" name="from" value={fromAirport} />
          <input type="hidden" name="to" value={toAirport} />
          <input type="hidden" name="departure" value={departureTime} />
          <input type="hidden" name="arrival" value={arrivalTime} />
          <input type="hidden" name="price" value={price} />
          <input type="hidden" name="validating" value={validatingAirlines} />

          <button type="submit">Confirm Booking</button>
          <button
            type="button"
            className="close-btn"
            onClick={onClose}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default FlightBookingModal;
